module.exports = __webpack_public_path__ + "img/img35.60beb1dc.svg";